var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fleet-list',_vm._b({attrs:{"kind":"product"}},'fleet-list',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }